import { useEffect } from 'react';
import { lockAppScroll } from '../utils/scrollLock';
import { useEscapeToClose } from '../utils/useEscapeToClose';
import './ImageLightbox.css';

interface ImageLightboxProps {
  imageUrl: string;
  altText: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function ImageLightbox({
  imageUrl,
  altText,
  isOpen,
  onClose,
}: ImageLightboxProps) {
  useEscapeToClose(isOpen, onClose);
  useEffect(() => (isOpen ? lockAppScroll() : undefined), [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>
          ✕
        </button>
        <img src={imageUrl} alt={altText} className="lightbox-image" />
        <div className="lightbox-caption">{altText}</div>
      </div>
    </div>
  );
}

